module.exports = __webpack_public_path__ + "static/media/Jon Bellion - Woodstock (Psychedelic Fiction).cc4507b7.mp3";